require ("./style.css")
import React from 'react';
import {Link} from 'react-router-dom';
import AcquireWebComponent from '../../framework/MaterialUI'
import BreadCrumb from '../CreateCampaigns/Title/Title'
import { Row, Col, FullRow } from '../../framework/Grid'
import LineGraphicSection from './LineGraphic';
import PieGraphicSection from './PieGraphic';
import TopLocationSection from './TopLocationSection';
import Tooltip from 'rc-tooltip';
import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import TipIcon from 'material-ui/svg-icons/action/info-outline';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import find from 'lodash/find';
import map from 'lodash/map';
import Select from 'react-select';
import { splitNumber, pdfReportHeaderDataUri, addPdfFooter, downLoadCSVFunc } from "../../../utils/utility" 
import moment from "moment-timezone/moment-timezone";

const pdfConverter = require('jspdf')
const html2canvas = require('html2canvas')

const styles={
  statsListItem : {
    width:'50%', 
    padding:'5px 0', 
    borderTop:"solid 1px #000"
  },
	tableHeaderStyle: {
		border: 'none',
    background: '#F5F5F5',
    fontSize: '12px',
    fontWeight: "bold"
	},
	tableHeaderColumn: {
		height: '35px',
		color: 'black',
		cursor: 'pointer',
		fontWeight: 'bolder',
		paddingLeft: '10px',
		position:'relative',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis'
	},
	tableTd: {
		paddingLeft: '10px',
		height: '30px',
		borderBottom: '1px solid black',
		whiteSpace:'nowrap',
		overflow:'hidden',
		textOverflow:'ellipsis'
	},
}
const TOP_LINK_STATS_COUNT = 5
class SocialChannelReport extends AcquireWebComponent {
  constructor(props) {
    super(props);
    let list = [];
    const segmentList = [];
    if (props.campaignDetail) {
      if (props.campaignDetail.socialDeployments.length > 1) {
        list.push({value: "aggregated", label:"Aggregate"});
      }
      map(props.campaignDetail.socialDeployments, (campaign)=>{
        list.push({value: campaign.id, label: campaign.name});
      })
      if (props.campaignDetail.socialDeployments.length > 0 && props.match.params.channelCampaignId !== "aggregated")  {
        const source = find(props.campaignDetail.socialDeployments, (dep)=>{
          return parseInt(dep.id, 10) === parseInt(props.match.params.channelCampaignId, 10)
        })
        map(source.channelCampaigns, (channelCampaign) => {
          segmentList.push({value: channelCampaign.id, label: channelCampaign.name})
        })

        if (segmentList.length > 1) {
          segmentList.unshift({value: "aggregated", label:"Aggregate"})
        }
      }
    }

    props.getCampaignById(props.match.params.id);
    if (props.segmentId) {
      if (props.match.params.channelCampaignId === "aggregated") {
        const source = find(props.campaignDetail.socialDeployments, (dep)=>{
          return find(dep.channelCampaigns, (campaign)=>{
            return parseInt(campaign.id, 10) === parseInt(props.segmentId, 10)
          })
        });
        if (source && source.channelCampaigns.length === 1) {
          map(source.channelCampaigns, (channelCampaign) => {
            segmentList.push({value: channelCampaign.id, label: channelCampaign.name})
          })
  
          if (segmentList.length > 1) {
            segmentList.unshift({value: "aggregated", label:"Aggregate"})
          }
          props.getSocialChannelAggregatedReport(props.match.params.id, source.id, props.reportDateRange, props.segmentId);
          props.getSocialChannelStatsAggregated(props.match.params.id, source.id, props.reportDateRange, props.segmentId);
        } else {
          props.getSocialChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);
          props.getSocialChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId, props.reportDateRange);          
        }
      } else {
        props.getSocialChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, 
          props.reportDateRange, props.segmentId);
        props.getSocialChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId,
          props.reportDateRange, props.segmentId);
      }
    } else {
      props.getSocialChannelAggregatedReport(props.match.params.id, props.match.params.channelCampaignId, 
        props.reportDateRange);
      props.getSocialChannelStatsAggregated(props.match.params.id, props.match.params.channelCampaignId,
        props.reportDateRange);
    }
    this.state={
      groupCampaignId: props.match.params.id,
      emailCampaignList: list,
      emailSegmentList: segmentList,
      showDownloadDialog : false,
      onPdfReportDownload: false,
      onCsvReportDownload: false,
      disabledBtnDownload: false,
      sectionWidth: '601px'
    }

    if (props.match.params.channelCampaignId !== "aggregated") {
      if (props.segmentId && props.segmentId !== "aggregated") {
        this.props.getCampaignTopLinkStats(props.match.params.id, props.segmentId, 
          props.reportDateRange, TOP_LINK_STATS_COUNT);
        this.props.getCampaignTopLocationClickStats(props.match.params.id, props.segmentId,
          props.reportDateRange, TOP_LINK_STATS_COUNT);  
        }
    }

    if (props.match.params.channelCampaignId === "aggregated" && list.length === 1) {
      props.setChannelCampaignId({value: list[0].value});
      props.history.push(`/campaigns/report/${props.match.params.id}/social/${list[0].value}`)
    } else {
      if (props.match.params.channelCampaignId !== "aggregated")
        props.setChannelCampaignId({value: props.match.params.channelCampaignId});
    }
  }

  updateDimensions(){
    const containerEls = document.getElementsByClassName("campaign-graph-container")
    if (containerEls.length > 0){
      const w = containerEls[0].offsetWidth / 2 - 10;
      this.setState({
        sectionWidth: w + 'px'
      })
    }
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions.bind(this));
      this.setSegmentId({value: undefined})
  }
  handleDownload(e) {
    e.preventDefault();

    if (this.refs.cbPDF.state.switched) {
      this.downloadPdfReport();
    }

    if (this.refs.cbCSV.state.switched) {
      this.downloadCsvReport();
    }
  }
  
  componentDidMount() {
    if (!this.props.campaignDetail) {
      this.props.getCampaignById(this.props.match.params.id);
      this.props.getSocialChannelAggregatedReport(this.props.match.params.id, this.props.match.params.channelCampaignId, 
        this.props.reportDateRange);
      this.props.getSocialChannelStatsAggregated(this.props.match.params.id, this.props.match.params.channelCampaignId,
        this.props.reportDateRange);
      this.props.setChannelCampaignId({value: this.props.match.params.channelCampaignId});
      if (this.props.match.params.channelCampaignId !== "aggregated"){
        if (this.props.segmentId && this.props.segmentId !== "aggregated") {
          this.props.getCampaignTopLinkStats(this.props.match.params.id, this.props.segmentId, 
            this.props.reportDateRange, TOP_LINK_STATS_COUNT);
          this.props.getCampaignTopLocationClickStats(this.props.match.params.id, this.props.segmentId, 
            this.props.reportDateRange, TOP_LINK_STATS_COUNT);
        }
      }
    }

    window.addEventListener("resize", this.updateDimensions.bind(this));
    this.updateDimensions()
  }
  
  componentWillReceiveProps(nextProps) {   
    if (!isEqual(nextProps.campaignDetail, this.props.campaignDetail)){
      const list = nextProps.campaignDetail.socialDeployments.length > 1 ? 
        [{value: "aggregated", label:"Aggregate"}] : [];
      map(nextProps.campaignDetail.socialDeployments, (campaign)=>{
        list.push({value: campaign.id, label: campaign.name});
      })
      this.props.selectClient(nextProps.campaignDetail.clientId);
      this.setState({
        emailCampaignList: list
      })
      if (this.props.match.params.channelCampaignId !== "aggregatted"){
        const dep = find(nextProps.campaignDetail.socialDeployments, (deploy)=>{
          return parseInt(deploy.id, 10) === parseInt(this.props.match.params.channelCampaignId, 10)
        })
        if (dep){
          const segmentList = []
          map(dep.channelCampaigns, (campaign)=>{
            segmentList.push({value: campaign.id, label: campaign.name})
          })
          if (segmentList.length > 1) {
            segmentList.unshift({value: "aggregated", label:"Aggregate"})
          }
          this.setState({emailSegmentList: segmentList})
          this.props.setSegmentId({value: segmentList[0].value});
        }
      }
    }
    if ((nextProps.reportDateRange !== this.props.reportDateRange) || 
      (nextProps.channelCampaignId !== this.props.channelCampaignId) ||
      (nextProps.match.params.channelCampaignId !== this.props.match.params.channelCampaignId) ||
      (nextProps.segmentId !== this.props.segmentId)){
      const channelCampaignId = nextProps.match.params.channelCampaignId ? nextProps.match.params.channelCampaignId : 
        this.props.match.params.channelCampaignId;
      if (channelCampaignId !== "aggregated") {
        if (nextProps.campaignDetail){
          const dep = find(nextProps.campaignDetail.socialDeployments, (deploy)=>{
            return parseInt(deploy.id, 10) === parseInt(channelCampaignId, 10)
          })
          if (dep){
            const segmentList = []
            map(dep.channelCampaigns, (campaign)=>{
              segmentList.push({value: campaign.id, label: campaign.name})
            })
            if (segmentList.length > 1) {
              segmentList.unshift({value: "aggregated", label:"Aggregate"})
            }
            const sid = ((parseInt(channelCampaignId, 10) !== parseInt(this.props.channelCampaignId, 10)) || (!nextProps.segmentId)) ?
             segmentList[0].value : nextProps.segmentId;
            this.setState({emailSegmentList: segmentList})
            this.props.setSegmentId({value: nextProps.segmentId ? nextProps.segmentId : sid});

            if (sid !== "aggregated"){
              this.props.getCampaignTopLinkStats(this.props.match.params.id, sid, 
                nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
              this.props.getCampaignTopLocationClickStats(this.props.match.params.id, sid, 
                nextProps.reportDateRange, TOP_LINK_STATS_COUNT);
            }

            this.props.getSocialChannelStatsAggregated(this.props.match.params.id, channelCampaignId, 
              nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
            this.props.getSocialChannelAggregatedReport(this.props.match.params.id, channelCampaignId, 
              nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange, sid);
          }

        } 
      } else {
        this.setState({emailSegmentList: []})
        this.props.getSocialChannelStatsAggregated(this.props.match.params.id, channelCampaignId, 
          nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
        this.props.getSocialChannelAggregatedReport(this.props.match.params.id, channelCampaignId, 
          nextProps.reportDateRange ? nextProps.reportDateRange : this.props.reportDateRange);
      }
    }
    /*
    if (nextProps.client_id !== this.props.client_id && (this.props.client_id))  {
			this.props.history.push("/campaigns");
		}*/
  }

  dateItem() {
		return (
			[
				{value : "life-of-campaign", label:"Life of Campaign"},
				{value : "yesterday", label:"Yesterday"},
				{value : "today", label:"Today"},
				{value: "last-7-days", label:"Last 7 Days"},
				{value: "last-30-days", label:"Last 30 Days"}
			]
		)
  }
  
	reportDateFilter(dayRange) {
		let result = "";
		switch (dayRange) {
			case "yesterday":
				result = "Yesterday"
				break;
			case "today":
				result = "Today"
				break;
			case "last-7-days":
				result = "Last 7 Days";
				break;
			case "last-30-days":
				result = "Last 30 Days";
				break;
			case "life-of-campaign":
			default:
				result = "Life of Campaign";
				break;
		}
		return result;
  }

  formatTopLinkRate(obj) {
    if (obj && obj.clickrate) {
      const result = obj.clickrate.toLocaleString("en-US",  { style:"percent", maximumFractionDigits: 2 }) + "";
      return result;
    } 

    return undefined;
  }

  topLinkStatsChart (props) {
    const { topLinkStats} = props;
    const channelCampaignId = props.match.params.channelCampaignId;
    if (channelCampaignId !== "aggregated" && (!isUndefined(topLinkStats))) {
      return (
        <PieGraphicSection title={"Top Links Clicked"} key={'top-link-stats-section'} 
          data={topLinkStats} hideOverflow={true} fieldDisplayFunc={this.formatTopLinkRate}
          showGraphic={true} 
          footer={<Link className="section-link" to={`/campaigns/report/${this.props.match.params.id}/social/${this.props.channelCampaignId}/${this.props.segmentId}/top-links-click`}>
            View More Top Links</Link>}
        />
      )
    }

    return "";
  }

  topLocationStats(props) {
    const { topLocationOpensStats } = props;
    return (
      <TopLocationSection title={"Top Locations by Clicks"} key={'top-locations-by-opens'} data={topLocationOpensStats}/>
    )
  }

  statsList(props) {
    if (props.socialAggregatedStats){
      const {segmentId} = props;
      const {channelCampaignId} = props.match.params
      const container =  (
        <FullRow style={{fontSize:"16px"}} className="light-grey-border no-margin-left no-margin-right no-padding mb-20 pb-20 pr-10 campaign-stats-container">
          <h3 className="pl-10" style={{fontSize:'24px', fontWeight:'bold'}}>Facebook Campaign Statistics</h3>
          <div style={{position:"absolute", top:'25px', right:'12px'}} className="tooltip-container">
						<Tooltip placement="right"
                  overlayClassName="campaign-report-legend"
                  overlayStyle={{ width: "288px" }}
                  overlay={
                    <div className="legend-overlay-container">
                      <strong>Facebook Campaign Statistics Definitions</strong>
                      <hr className="black-hr" />
                      <strong>Reach: </strong>The number of unique people
                      who saw your ad
                      <br /><br />
                      <strong>Impressions: </strong>The number of times an 
                      instance of your ad is on screen 
                      <br /><br />
                      <strong>Frequency: </strong>The average number of times 
                      each person saw your ad
                      <br /><br />
                      <strong>Clicks - </strong>The number of clicks on 
                      links within the ad that led to destinations
                      or experiences, on or off Facebook
                      <br /><br />
                      <strong>Post Engagements: </strong>The total number of
                      actions that people take involving your ads
                      while they're running. Actions can include
                      clicking on a link, commenting on or
                      sharing the ads, claiming an offer, viewing
                      a photo or video.
                      <br /><br />
                      <strong>Engagement Rate: </strong>The percentage of
                      times people saw your ad and performed
                      either a link click, reaction, shares,
                      forward, or comment.
                    </div>
                  }
                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                  <TipIcon
                    style={{color: 'black', width: '24px', height: '24px', marginTop: '0px', marginLeft: '0px', cursor: 'pointer'}}
                  />
                </Tooltip>
					</div>
          <div className="spread-table mt-20 ml-10">
            <table>
              <thead>
                <tr>
                {(segmentId && segmentId !== "aggregated") && 

                  <th style={{padding: "10px 20px"}}>Reach</th>
                }
                  <th style={{padding: "10px"}}>Impressions</th>
                {(segmentId && segmentId !== "aggregated") && 
                  <th style={{padding: "10px"}}>Frequency</th>
                }
                  <th style={{padding: "10px"}}>Clicks</th>
                  <th style={{padding: "10px"}}>Post Engagements</th>
                  <th style={{padding: "10px", paddingRight:"20px", textAlign:'right'}}>Engagement Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                {(channelCampaignId.toLowerCase() !== "aggregated" && segmentId && segmentId !== "aggregated") && 
                  <td style={{paddingLeft:"20px"}}>{splitNumber(props.socialAggregatedStats.reach)()}</td>
                }
                  <td>{splitNumber(props.socialAggregatedStats.impressions)()}</td>
                {(channelCampaignId.toLowerCase() !== "aggregated" && segmentId && segmentId !== "aggregated" && props.socialAggregatedStats.frequency) && 
                  <td>{props.socialAggregatedStats.frequency.toLocaleString()}</td>
                }
                  <td>{splitNumber(props.socialAggregatedStats.fbclicks)()}</td>
                  <td>{splitNumber(props.socialAggregatedStats.postengagements)()}</td>
                  <td style={{paddingRight:"20px", textAlign:'right'}}>{props.socialAggregatedStats.engagementrate ? props.socialAggregatedStats.engagementrate.toLocaleString("en-US",  { style:"percent", maximumFractionDigits: 2 }) : ""}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <FullRow className="no-margin-bottom no-padding-bottom definition-container" style={{display:"none"}}>
						<h3>DEFINITIONS</h3>
            <div className="mb-10" style={{fontSize:'13px'}}>
              <strong>Reach: </strong>The number of unique people who saw your ad 
            </div>
            <div className="mb-10" style={{fontSize:'13px'}}>
              <strong>Impressions: </strong>The number of times an instance of your ad is on screen 
            </div>
            <div className="mb-10" style={{fontSize:'13px'}}>
              <strong>Frequency: </strong>The average number of times each person saw your ad
            </div>
						<div className="mb-10" style={{fontSize:'13px'}}>
              <strong>Clicks - </strong>The number of clicks on 
                      links within the ad that led to destinations
                      or experiences, on or off Facebook            
            </div>
            <div className="mb-10" style={{fontSize:'13px'}}>
              <strong>Post Engagements: </strong>The total number of
                      actions that people take involving your ads
                      while they're running. Actions can include
                      clicking on a link, commenting on or
                      sharing the ads, claiming an offer, viewing
                      a photo or video.
            </div>
            <div className="no-margin-bottom" style={{fontSize:'13px'}}>
              <strong>Engagement Rate: </strong>The percentage of
                      times people saw your ad and performed
                      either a link click, reaction, share,
                      forward, or comment.
            </div>
					</FullRow>
        </FullRow>
      )      
      return container;
    }
    return ""
  }

  downloadPdfReport() {
		this.setState({onPdfReportDownload: true, showDownloadDialog: false});
		this.handlePdfDownload();
  }
  
  downloadCsvReport() {
    this.setState({onCsvReportDownload: true, showDownloadDialog: false});
		this.handleCsvDownload();
  }


  _addPdfHeader(pdf, client_name, bu_name, campaignDetail){
    pdf.setFillColor(127,127,127);
    pdf.rect(0, 15 , 210, 10, 'F');

    pdf.setTextColor(0, 0, 0)
    pdf.setFontSize(9)
    pdf.setFontType('bold')
    pdf.addImage(pdfReportHeaderDataUri(), 'PNG', 10.5, 3, 60, 0)
    pdf.text(198, 8, moment().format('MMMM DD, YYYY'), null, null, 'right');

    pdf.setTextColor(255, 255, 255)
    pdf.setFontType('bold')
    pdf.text(12, 21, 'Client:')			
    //const lenClientName = getTextSize(client_name.trim(), 'helvetica') 
    pdf.setFontType('normal')
    pdf.text(26, 21, client_name ? client_name.trim() : "")
    //cm to inches
    let start = 90; //46 + lenClientName.width * 0.3937 + 0.4
    if (!isEmpty(bu_name)) {
      pdf.setFontType('bold')
      pdf.text(start, 21, 'Business Unit:')
      start += 26.5
      pdf.setFontType('normal')
      pdf.text(start, 21, bu_name ? bu_name.trim() : '')
    }
    pdf.setFillColor(255)
    start = 12
    pdf.setTextColor(0, 0, 0)
    pdf.setFontSize(10)
    pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name );
  }

  handlePdfDownload() {
    const { clients, client_info, channelCampaignId, campaignDetail, segmentId } = this.props;
		let client_name = client_info.name;
		let bu_name = "";
		if (client_info.parentClientId) {
      const parent_client = find(clients, (c) => {return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10)})
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
    }
    //const dateRangeStr = this.dateItem().filter((data)=>{return data.value === reportDateRange})[0].label;
    const deployment = channelCampaignId === "aggregated" ? null :       
    campaignDetail.socialDeployments.filter((campaign) => {
      return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)})[0];
    const channelCampaignName = channelCampaignId === "aggregated" ? "Aggregated" : deployment.name
		let pdfFileName = campaignDetail.name + "_Facebook_";
      
    if (channelCampaignName !== "Aggregated") {
      if (segmentId === "aggregated") {
        pdfFileName += "Segment_Aggregagte"
      } else {
        const emailCampaignDetail = find(deployment.channelCampaigns, (campaign)=>{
          return parseInt(campaign.id, 10) === parseInt(segmentId, 10)
        })
        pdfFileName += emailCampaignDetail.name
      }
    } else {
      pdfFileName += "Deployment_Aggregate"
    }

    const pdf = new pdfConverter('p', 'mm', 'a4')
		pdf.setFont("Helvetica")
		pdf.setFontType("normal")
		pdf.setFontSize(9)
		const pageWidth = 186

    const el_selector_container = document.getElementsByClassName("selector-container")[0];
    const el_campaign_top_link_container = document.getElementsByClassName("campaign-top-links-container")[0];
    const el_campaign_top_link_stats_container = document.getElementsByClassName("top-links-stats")[0]
    const el_campaign_top_location_stats_container = document.getElementsByClassName("top-location-stats")[0]

		const el_campaign_graph = document.getElementsByClassName("campaign-graph-container")[0];
    const el_campaign_stats = document.getElementsByClassName("campaign-stats-container")[0];
    const el_email_campaign_detail = (channelCampaignId === "aggregated" || (segmentId && segmentId === "aggregated")) ? 
      null : document.getElementsByClassName("email-campaign-detail-container")[0];

    let canvasSelectorContainer = null;
		let canvasTopLinkContainer = null;
		let canvasGraph = null;
    let canvasSummary = null;
    let canvasEmailCampaignDetail = null;
    let isCanvasSelectorReady = false;
		let isCanvasTopLinkReady = (channelCampaignId === "aggregated" || (segmentId && segmentId === "aggregated")) ? true: false;
		let isCanvasGraphReady = false;
    let isCanvasSummaryReady = false;
    let isCanvasEmailCampaignReady = (channelCampaignId === "aggregated" || (segmentId && segmentId === "aggregated")) ? true : false;
		const oriWidth = el_campaign_graph.offsetWidth;
    const oriTopLinkWidth = (channelCampaignId === "aggregated" || (segmentId && segmentId === "aggregated")) ? 0 : el_campaign_top_link_container.offsetWidth;
    
		document.getElementsByClassName("nav-btn-download-report")[0].style.display="none";
		document.getElementsByClassName("definition-container")[0].style.display="block";
    document.getElementsByClassName("tooltip-container")[0].style.display="none";
    if (document.getElementsByClassName("section-link").length > 0)
      document.getElementsByClassName("section-link")[0].style.display="none";
		const tableLinks = document.getElementsByClassName("agg-title-link");
		let linkColor = null
		if (tableLinks.length > 0) {
			linkColor = tableLinks[0].style.color;
			forEach(tableLinks, (el)=>{
				el.style.color = "#000";
			})
		}

    if (el_campaign_top_link_container)
      el_campaign_top_link_container.style.width = "1034px";
    if (el_campaign_top_link_stats_container)
      el_campaign_top_link_stats_container.style.width = "507px";
    if (el_campaign_top_location_stats_container)
      el_campaign_top_location_stats_container.style.width = "507px";

    el_selector_container.style.width = "1024px"
		el_campaign_graph.style.width = "1024px";
    el_campaign_stats.style.width = "1024px";
    if (el_email_campaign_detail) {
      el_email_campaign_detail.style.width = "1024px";
    }

    setTimeout(function(){
			html2canvas(el_selector_container, {logging: false}).then(function (canvas) {
				canvasSelectorContainer = canvas;
				isCanvasSelectorReady = true;
				el_selector_container.style.width = oriWidth + 'px';
			})
    }, 50)
    if (channelCampaignId !== "aggregated" && (segmentId && segmentId !== "aggregated")){
      setTimeout(function () {
        html2canvas(el_campaign_top_link_container, {logging:false}).then(function (canvas) {
          canvasTopLinkContainer = canvas
          isCanvasTopLinkReady = true
          el_campaign_top_link_container.style.width = oriTopLinkWidth + 'px'
          if (el_campaign_top_link_stats_container)
            el_campaign_top_link_stats_container.style.width = (oriTopLinkWidth / 2 - 10) + 'px';
          if (el_campaign_top_location_stats_container)
            el_campaign_top_location_stats_container.style.width = (oriTopLinkWidth / 2 - 10) + 'px';
        })
      }, 50);
      setTimeout(function () {
        html2canvas(el_email_campaign_detail, {logging:false}).then(function (canvas) {
          canvasEmailCampaignDetail = canvas
          isCanvasEmailCampaignReady = true
          el_email_campaign_detail.style.width = oriWidth + 'px'
         })
      }, 50);
    }

    setTimeout(function() {
			html2canvas(el_campaign_graph, {logging: false}).then(function (canvas) {
				canvasGraph = canvas;
				isCanvasGraphReady = true;
				el_campaign_graph.style.width = oriWidth + 'px';
			})
		}, 50);
		setTimeout(function() {
			html2canvas(el_campaign_stats, {logging: false}).then(function (canvas) {
				canvasSummary = canvas;
				isCanvasSummaryReady = true;
				el_campaign_stats.style.width = oriWidth + 'px';
			})
		}, 50);

		let top = 37
		const left = 12
		let intervalId = setInterval(function () {
      if (isCanvasTopLinkReady === false || isCanvasSummaryReady === false || isCanvasGraphReady === false || 
        isCanvasEmailCampaignReady === false || isCanvasSelectorReady === false) {
				console.log("PDF Generating...")
			} else {
				clearInterval(intervalId);
				setTimeout(function(){
          this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
          top = 35;
          pdf.addImage(canvasSelectorContainer.toDataURL(), 'PNG', left, top, pageWidth, 0);
          top += (canvasSelectorContainer.height * pageWidth / canvasSelectorContainer.width) + 3;
					//pdf.addImage(canvasDatePicker.toDataURL(), 'PNG', left, top, pageWidth, 0);
          //top += (canvasDatePicker.height * pageWidth / canvasDatePicker.width);
          if (channelCampaignId !== "aggregated" && (segmentId && segmentId !== "aggregated")) {
            pdf.addImage(canvasEmailCampaignDetail.toDataURL(), "PNG", left, top, pageWidth, 0);
            top += (canvasEmailCampaignDetail.height * pageWidth / canvasEmailCampaignDetail.width) + 3;
          }
          pdf.addImage(canvasGraph.toDataURL(), 'PNG', left, top, pageWidth, 0);
					top += (canvasGraph.height * pageWidth / canvasGraph.width) + 3;
          pdf.addImage(canvasSummary.toDataURL(), 'PNG', left, top, pageWidth, 0);
          if (channelCampaignId !== "aggregated" && (segmentId && segmentId !== "aggregated")) {
            addPdfFooter(pdf);
            pdf.addPage('a4', 'p');
            this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
            top = 35;
            //top += (canvasSummary.height * pageWidth / canvasSummary.width) + 3;
            pdf.addImage(canvasTopLinkContainer.toDataURL(), 'PNG', left - 2, top, pageWidth + 2, 0);
          }
					addPdfFooter(pdf)

          document.getElementsByClassName("nav-btn-download-report")[0].style.display="block";
					document.getElementsByClassName("definition-container")[0].style.display="none";
          document.getElementsByClassName("tooltip-container")[0].style.display="block";
          if (document.getElementsByClassName("section-link").length > 0)
            document.getElementsByClassName("section-link")[0].style.display="block";
					if (tableLinks.length > 0) {
						forEach(tableLinks, (el)=>{
							el.style.color = linkColor;
						})
					}
					pdfFileName = pdfFileName.replace(new RegExp(' ', 'g'), '_') + "_" + moment().format("YYYYMMDD") + ".pdf";
					pdf.save(pdfFileName)
					this.setState({onPdfReportDownload: false});
				}.bind(this), 100);
			}
		}.bind(this), 50);
  }
  
  handleCsvDownload() {
    const { clients, client_info, channelCampaignId, campaignDetail, reportDateRange, socialAggregatedReport, 
      socialAggregatedStats, segmentId } = this.props;
    const {impressions, fbclicks, postengagements, engagementrate, reach, frequency } = socialAggregatedStats

		let client_name = client_info.name;
		let bu_name = "";
		if (client_info.parentClientId) {
			const parent_client = find(clients, (c) => {return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10)})
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
    }
    
    const deployment = channelCampaignId === "aggregated" ? null :       
      campaignDetail.socialDeployments.filter((campaign) => {
        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)})[0];
    const channelCampaignName = deployment ? deployment.name : "Aggregated";
		let csvFileName = campaignDetail.name + "_Facebook_";
    if (channelCampaignName !== "Aggregated") {
      if (segmentId === "aggregated") {
        csvFileName += "Segment_Aggregagte"
      }
    } else {
      csvFileName += "Deployment_Aggregate"
    }

    let title_line = channelCampaignName === "Aggregated" ? 'AudienceAnywhere Aggregate Facebook Deployment Report  ,,,,,,,,\r\n' : 
    segmentId && segmentId !== "aggregated" ? 'AudienceAnywhere Facebook Segment Campaign Report  ,,,,,,,,\r\n' :
    'AudienceAnywhere Aggregate Facebook Segment Campaign Report  ,,,,,,,,\r\n'

		let date_line = "Today's Date," + moment().format("MM/DD/YY") + ",,,,,,,\r\n"
		let client_line = "Client," + client_name + ",,,,,,,\r\n";
		let business_unit_line = isEmpty(bu_name) ? "" : "Business Unit," + bu_name + ",,,,,,,\r\n";
		let date_filter_line = "Date Filter," + this.reportDateFilter(reportDateRange) + ",,,,,,,\r\n";
		const split_line = ",,,,,,,,\r\n";
    let campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";
    if (channelCampaignName !== "Aggregated" && segmentId !== "aggregated") {
      const socialCampaignDetail = find(deployment.channelCampaigns, (campaign)=>{
        return parseInt(campaign.id, 10) === parseInt(segmentId, 10)
      })
      csvFileName += socialCampaignDetail.name;
      const email_campaign_name = "Facebook Segment Name," + socialCampaignDetail.name + ",,,,,,,\r\n";
      const email_campaign_status = "Facebook Segment Status," + socialCampaignDetail.status + ",,,,,,,\r\n";
      const email_campaign_start_date = "Facebook Segment Start Date," + moment(socialCampaignDetail.startDate).format("MM/DD/YYYY") + ",,,,,,,\r\n";
      const email_campaign_end_date = socialCampaignDetail.endDate ? 
        "Facebook Segment End Date," + moment(socialCampaignDetail.endDate).format("MM/DD/YYYY") + ",,,,,,,\r\n" : 
        "Facebook Segment End Date,,,,,,,,\r\n";
      campaign_group_name_line += "Facebook Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
      campaign_group_name_line += email_campaign_name;
      campaign_group_name_line += email_campaign_status;
      campaign_group_name_line += email_campaign_start_date;
      campaign_group_name_line += email_campaign_end_date;
      campaign_group_name_line += ",,,,,,,,\r\n";
    } else {
      if (channelCampaignName !== "Aggregated") {
          campaign_group_name_line += "Facebook Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
      }
    }

    let campaign_grouped_title = "Facebook Impressions and Clicks,,,,,,,,\r\n,";
    let campaign_grouped_impressions_row = "Impressions,"
    let campaign_grouped_click_row = "Clicks,"
    let campaign_grouped_post_engagements_row = "Engagement Rate,"
    if (socialAggregatedReport) {
			socialAggregatedReport.forEach(data => {
        campaign_grouped_title += data.time + ",";
        campaign_grouped_impressions_row += !isUndefined(data.impressions) ? (data.impressions + ",") : ",";
        campaign_grouped_click_row += !isUndefined(data.fbclicks)?(data.fbclicks + ",") : ",";
        campaign_grouped_post_engagements_row += !isUndefined(data.postengagements) ? (data.postengagements + ",") : ",";
			});
    }
    campaign_grouped_title += "\r\n";
    campaign_grouped_impressions_row += "\r\n";
    campaign_grouped_click_row += "\r\n";
    campaign_grouped_post_engagements_row += "\r\n";

    const aggregated_email_campaign_stats_title = channelCampaignName === "Aggregated"  ?
      "Aggregate Facebook Deployment Statistics,,,,,,,,\r\n" : segmentId && segmentId === "aggregated" ?
      "Aggregate Facebook Segment Statistics,,,,,,,,\r\n" : "Facebook Segment Statistics,,,,,,,,\r\n";
    const stats_reach_row = segmentId && segmentId !=="aggregated" ? "Reach, " + reach + ",,,,,,,\r\n" : "";
    const stats_impressions_row = "Impressions, " + impressions + ",,,,,,,\r\n";
    const stats_frequency_row = segmentId && segmentId !=="aggregated" ?
     "Frequency, " + frequency.toLocaleString() + ",,,,,,,\r\n" : "";
    const stats_clicks_row = "Clicks," + fbclicks + ",,,,,,,\r\n";
    const stats_post_engagements_row = "Post Engagements," + postengagements + ",,,,,,,\r\n";
    const stats_engagement_rate_row = engagementrate ? "Engagement Rate," + engagementrate.toLocaleString("en-US",{ style:"percent", maximumFractionDigits: 2 }) + ",,,,,,,\r\n" : "Engagement Rate,,,,,,,,\r\n";

    const definition_title = "Definitions,,,,,,,,\r\n";
    const define_reach_line = segmentId && segmentId !=="aggregated" ? "Reach: The number of unique people who saw your ad ,,,,,,,,\r\n" : "";
    const define_impressions_line = "Impressions: The number of times an instance of your ad is on screen ,,,,,,,,\r\n";
    const define_frequency_line = segmentId && segmentId !=="aggregated" ? "Frequency: The average number of times each person saw your ad ,,,,,,,,\r\n" : "";
    const define_clicks_line = '"Clicks (Link): The number of clicks on links within the ad that led to destinations or experiences, on or off Facebook ",,,,,,,,\r\n';
    const define_post_engagement_line = '"Post Engagements: The total number of actions that people take involving your ads while they are running. Actions can include clicking on a link, commenting on or sharing ads, claiming an offer, viewing a photo or video",,,,,,,,\r\n';
    const define_engagement_rate_line = '"Engagement Rate: The percentage of times people saw your ad and performed either a link click, reaction, shares, forward, or comment",,,,,,,,\r\n';
    
    let resultString = title_line + date_line + client_line + business_unit_line + date_filter_line + split_line +
      campaign_group_name_line + split_line + campaign_grouped_title + campaign_grouped_impressions_row + campaign_grouped_click_row +
      campaign_grouped_post_engagements_row + split_line + aggregated_email_campaign_stats_title + stats_reach_row +
      stats_impressions_row + stats_frequency_row + stats_clicks_row + stats_post_engagements_row + stats_engagement_rate_row + 
      split_line + split_line + definition_title + define_reach_line + define_impressions_line + define_frequency_line +
      define_clicks_line + define_post_engagement_line + define_engagement_rate_line + split_line;
    
    if (channelCampaignName !== "Aggregated" || (segmentId !== 'aggregated')) {
      resultString += ",,,,,,,,      \r\n";
      resultString += "Top Location by Clicks,,,,,,,,\r\n";
      if (this.props.topLocationOpensStats) {
        map(this.props.topLocationOpensStats, (stat)=>{
          resultString += stat.state + "," + stat.clicks + ",,,,,,,\r\n";
        })
      }
    }
		csvFileName += "_" + moment().format("YYYYMMDD");
		csvFileName = csvFileName.replace(new RegExp(' ', 'g'), '_');
		downLoadCSVFunc(resultString, csvFileName);
		setTimeout(function(){
			this.setState({onCsvReportDownload: false})
		}.bind(this), 2000)
	}
  
  setChannelCampaignId(data) {
    this.props.setChannelCampaignId(data);
    const {match} = this.props

    if (data.value !== "aggregated") {
      const deployment = find(this.props.campaignDetail.socialDeployments, (deployment)=>{
        return deployment.id === data.value
      })
      if (deployment) {
        const segmentList = []
        map(deployment.channelCampaigns, (channelCampaign) => {
          segmentList.push({value: channelCampaign.id, label: channelCampaign.name})
        })
        if (segmentList.length > 1) {
          segmentList.unshift({value: "aggregated", label:"Aggregate"})
          this.props.setSegmentId({value: "aggregated"})
        } else {
          this.props.setSegmentId({value: segmentList[0].id})
        }
        this.setState({emailSegmentList: segmentList})

        this.props.getSocialChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
        this.props.getSocialChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange, segmentList[0].value);
      }
    }else{
      this.props.getSocialChannelStatsAggregated(match.params.id, data.value, this.props.reportDateRange);
      this.props.getSocialChannelAggregatedReport(match.params.id, data.value, this.props.reportDateRange);
    }
    this.props.history.push(`/campaigns/report/${match.params.id}/social/${data.value}`)
  }

  setSegmentId(data) {
    this.props.setSegmentId(data);
  }

  cbPDFChange(e, isInputChecked) {
    const result = (!this.refs.cbCSV.state.switched) && (!isInputChecked);
    this.setState({disabledBtnDownload: result});
  }

  cbCSVChange(e, isInputChecked) {
    const result = (!this.refs.cbPDF.state.switched) && (!isInputChecked);
    this.setState({disabledBtnDownload: result});
  }

  render() {
    const { match, campaignDetail, reportDateRange, socialAggregatedReport, setReportDateRange, client_info, segmentId } = this.props;
    const showTopLocationOpens = client_info && client_info.clientReportDetailSetting && 
      client_info.clientReportDetailSetting.topLocationChannelReport === true;
    const channelCampaignId = match.params.channelCampaignId;
    const lineData = []
		if (socialAggregatedReport) {
			socialAggregatedReport.forEach(data => {
        lineData.push({time: data.time, postengagements: data.postengagements, fbclicks: data.fbclicks,
          impressions: data.impressions});
			});
    }
    const tableSubTitle = "Date: " ;
    const tableSubTitleText = this.reportDateFilter(reportDateRange);
    const crumbs = [];
    const crumbsLink = []
    const channelCampaignDetail = (channelCampaignId === "aggregated" || (!campaignDetail)) ? null : 
      campaignDetail.socialDeployments.filter((campaign) => {
        return parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)})[0];
    let segment = undefined;

    if (campaignDetail && campaignDetail.socialDeployments) {
      crumbs.push(campaignDetail.name);
      crumbsLink.push(`/campaigns/report/${campaignDetail.id}`);
      if ((channelCampaignId === undefined) || (channelCampaignId === "aggregated")) {
        crumbs.push("Facebook Campaign: Aggregate")
      } else {
        map(campaignDetail.socialDeployments, (dep)=>{
          if (parseInt(dep.id, 10) === parseInt(channelCampaignId, 10)) {
            if (segmentId) {
              segment = find(dep.channelCampaigns, (s)=>{
                return parseInt(s.id, 10) === parseInt(segmentId, 10);
              })
            }
            crumbs.push("Facebook ")
          }
        })
      }
    }
    return (
      <div className="campaign-report-container" style={{background:"#FFFFFF", fontSize: '16px'}}>
        <BreadCrumb
          crumbs={crumbs}
          crumbsLink={crumbsLink}
          linkName="Campaigns" showDownloadBtn={true}
          handleDownload={()=>{this.setState({showDownloadDialog: true});}}
          selected_client={this.props.client_id}
        />{/*
        						<button className="pull-right btn btn-aa-default btn-download" 
                onClick={(e)=>{e.preventDefault();this.setState({showDownloadDialog: true});}}>Download Report</button>
        */}
        <div className="light-grey-border mt-20 selector-container">
          <FullRow className="pt-10, no-margin-bottom" style={{fontWeight:"bold", fontSize:'24px'}}>
            Facebook Selection
          </FullRow>
          <Row className="no-padding-top no-margin-bottom ">
            <Col xs="3" sm="3" md="3" lg="3" className="no-padding-right"><strong>Facebook Deployment</strong></Col>
            <Col xs="3" sm="3" md="3" lg="3">
              <Select className="campaign-selector left-10 z-index-199"
                value={channelCampaignId ? channelCampaignId : isEmpty(this.state.emailCampaignList) ? "" : this.state.emailCampaignList.length > 1 ? "aggregated" : this.state.emailCampaignList[0].value}
                clearable={false}
                searchable={false}
                options={this.state.emailCampaignList}
                placeholder={"Select Campaign"}
                onChange={this.setChannelCampaignId.bind(this)}
              />
            </Col>
            <Col xs="2" sm="2" md="2" lg="2" className="no-padding"><strong>Facebook Segment</strong></Col>
            <Col xs="4" sm="4" md="4" lg="4">
            {
              this.state.emailSegmentList.length > 0 &&
              <Select className="campaign-selector left-10 z-index-199"
                  value={segmentId ? segmentId : this.state.emailSegmentList.length > 0 ? this.state.emailSegmentList[0].value : 0}
                  clearable={false}
                  searchable={false}
                  options={this.state.emailSegmentList}
                  placeholder={"Select Segment"}
                  onChange={this.setSegmentId.bind(this)}
              />
            }
            </Col>

          </Row>
          <hr style={{margin:"-10px 20px 20px"}} />
          <Row className="no-padding-top no-margin-bottom">
            <Col xs="3" sm="3" md="3" lg="3"><strong>Date</strong></Col>
            <Col xs="3" sm="3" md="3" lg="3">
              <Select className="report-date-selector left-10 z-index-198"
                value={reportDateRange}
                clearable={false}
                searchable={false}
                options={this.dateItem()}
                placeholder={"Select Day"}
                onChange={setReportDateRange.bind(this)}
              />
            </Col>
          </Row>
        </div>
        {
          (channelCampaignDetail && (segmentId !== "aggregated") )&& (       
            <FullRow className="light-grey-border mt-20 no-margin-left no-margin-right no-padding mb-20 pr-10 email-campaign-detail-container">
              <h3 className="pl-10 mt-10" style={{fontSize:'24px', fontWeight:'bold'}}>Facebook Segment Details</h3>
              <table style={{width:"98%", marginLeft:'10px'}}>
                <thead style={styles.tableHeaderStyle}>
                  <tr style={{height:"42px"}}>
                    <th style={{width:'45%', paddingLeft:"20px"}}><strong>Segment Name</strong></th>
                    <th style={{width:'20%'}}><strong>Segment Status</strong></th>
                    <th style={{width:'18%'}}><strong>Segment Start Date</strong></th>
                    <th style={{width:'17%',paddingRight:"20px", textAlign:'right'}}><strong>Segment End Date</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{height:"42px"}}>
                    <td style={{width:'45%', paddingLeft:"20px", paddingReft:"50px",wordBreak: "break-word"}}>{segment ? segment.name : ""}</td>
                    <td style={{width:'20%'}}>{segment ? segment.status : ""}</td>
                    <td style={{width:'18%'}}>{segment ? moment(segment.startDate).format("MM/DD/YY") : ""}</td>
                    <td style={{width:'17%', paddingRight:"20px", textAlign:'right'}}>{segment && segment.endDate ? moment(segment.endDate).format("MM/DD/YY") : ""}</td>
                  </tr>
                </tbody>
              </table>
            </FullRow>)}
        <FullRow className="light-grey-border no-margin-left no-margin-right no-padding mt-20 mb-20 pb-20 pr-20 pl-10 campaign-graph-container">
          <h3 className="pl-10" style={{fontSize:'24px', fontWeight:'bold'}}>Facebook - Impressions, Clicks, and Post Engagements</h3>
					<LineGraphicSection animation={false} key={'line-section'} dataNames={["Impressions", "Clicks", "Post Engagements"]} dataKeys={['impressions', 'fbclicks', 'postengagements']}
						title="" data={lineData} subTitle={tableSubTitle} subTitleText={tableSubTitleText} />
        </FullRow>
        {
          this.statsList(this.props)
        }
        {
          ((channelCampaignId !== "aggregated" && segmentId && segmentId !== "aggregated") && 
          <FullRow className="no-margin-right no-padding campaign-top-links-container">
            {
              showTopLocationOpens && (            
              <Col xs="6" sm="6" md="6" lg="6" className="light-grey-border p-20 top-location-stats" style={{width: this.state.sectionWidth}}>
                { this.topLocationStats(this.props)}
              </Col>)

            }
          </FullRow>)
        }
        
        <Dialog open={this.state.onCsvReportDownload} style={{top: '-1.8em'}} modal={true}  contentStyle={{width:"500px"}}
					overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}>
					<Row className="mt-20">
							<Col offsetXs="1" offsetSm="1" offsetMd="1" offsetLg="1" xs="7" sm="7" md="7" lg="7" className="text-right">
									<div>{ "Downloading, please wait..."}</div>
							</Col>
							<Col xs="1" sm="1" md="1" lg="1">
									<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
							</Col>
					</Row>
				</Dialog>
				<Dialog open={this.state.onPdfReportDownload} style={{top: '-1.8em'}} modal={true}  contentStyle={{width:"500px"}}
					overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}>
					<Row className="mt-20">
							<Col offsetXs="1" offsetSm="1" offsetMd="1" offsetLg="1" xs="7" sm="7" md="7" lg="7" className="text-right">
									<div>{ "Downloading, please wait..."}</div>
							</Col>
							<Col xs="1" sm="1" md="1" lg="1">
									<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
							</Col>
					</Row>
				</Dialog>
				<Dialog open={this.state.showDownloadDialog} style={{top: '-1.8em'}} modal={true} 
          contentStyle={{width:"440px"}}>
            <FullRow className="no-margin-top no-padding" style={{fontSize: '16px', color:"#000"}}>
              <strong>Choose the type of file you would like to download</strong>
            </FullRow>
            <FullRow className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom" 
              style={{paddingLeft:"150px"}}>
              <Checkbox iconStyle={{fill:"#47A1AB", marginRight:'10px'}} label={"PDF File"} labelStyle={{fontSize:'13px'}}
                        defaultChecked={false} ref="cbPDF" onCheck={(e, isInputChecked) => this.cbPDFChange(e, isInputChecked)} />         
            </FullRow>
            <FullRow className="no-padding-top no-padding-right no-padding-bottom" style={{paddingLeft:"150px"}}>
              <Checkbox iconStyle={{fill:"#47A1AB", marginRight:'10px'}} label={"CSV File"} labelStyle={{fontSize:'13px'}}
                        defaultChecked={true} ref="cbCSV" onCheck={(e, isInputChecked) => this.cbCSVChange(e, isInputChecked)} />         
            </FullRow>
            <FullRow className="no-padding no-margin-bottom mt-20 text-center">
              <button type="button" onClick={()=>this.setState({showDownloadDialog: false})} 
                className="btn btn-default btn-aa-info mr-20">Cancel</button>
              <button type="button" onClick={this.handleDownload.bind(this)} disabled={this.state.disabledBtnDownload}
                className="btn btn-default btn-aa-default">Download File</button>
            </FullRow>
          </Dialog>
      </div>
    )
  }
}

export default SocialChannelReport


// WEBPACK FOOTER //
// ./src/components/Campaigns/Report/SocialChannelReport.jsx